import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-361387cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "noUpdates"
}

import { Icon } from '../../Atoms';
import { StatusDetailsTabView } from '../../Organisms';
import { RteContentType } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'InformationTabView',
  props: {
    heading: {},
    isEmpty: { type: Boolean },
    rteContent: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StatusDetailsTabView), { "rte-content": _ctx.rteContent }, {
    header: _withCtx(() => [
      _createElementVNode("h3", null, _toDisplayString(_ctx.heading), 1)
    ]),
    emptyStateContainer: _withCtx(() => [
      (_ctx.isEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(Icon), { "icon-name": "tickBlack" }),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('Information: no update')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["rte-content"]))
}
}

})